module.exports = __webpack_public_path__ + "static/media/warning.ad278315.svg";